// formConfig.jsplease_enter
const formConfig = {
    modify_collection_item: 'Modify collection item',
    add_collection_item: 'Add new collection item',
    id: 'ID',
    registration_type: 'Registration type',
    channel_id: 'Channel ID',
    forum_id: 'Forum ID',
    field_name: 'Field name',
    display_name: 'Display name',
    please_input_display_name: 'Please enter a display name',
    field_type: 'Field type',
    warning_field_type_selection: 'For name and phone number, please select the built-in field types; otherwise data statistics will be incorrect! Please note!!!!',
    upload_file_format: 'Upload file format',
    option_content: 'Option content',
    calendar_format: 'Calendar format',
    custom_format: 'Custom format',
    date_format_example: 'Format  : yyyy-MM-dd HH:mm:ss',
    date_value_example: 'Example value: 2023-08-18 20:08:08',
    max_selection_limit: 'Maximum number of selections',
    no_selection_limit: 'When this is empty or 0, there is no limit on the number of selectable items.',
    min_resume_word_count: 'Minimum word count for resume',
    no_min_word_count_limit: 'When this is empty or 0, there is no limit! Note: For English websites, the limit is based on the number of words.',
    max_resume_word_count: 'Maximum word count for resume',
    user_selection_lock: 'User selection cannot be modified after selection',
    field_required: 'This field is required',
    parent_option_and_display_condition: 'Parent option and display condition',
    parent_option: 'Parent option',
    parent_option_sort_notice: 'Note: The parent option sort must be placed before the child field.',
    display_condition: 'Display condition',
    display_condition_notice: 'When the parent option selects this condition, this field will be displayed.',
    hint_text: 'Hint text',
    hint_when_value_empty: 'Prompt when value is empty',
    hint_when_verification_failed: 'Prompt when verification fails',
    notice_content: 'Notice content',
    submit_immediately: 'Submit immediately',
    notice_priority_system_fields: 'Note: Priority should be given to system fields, otherwise it may affect later statistics and data export!',
    selected_form_items: 'Selected form items',
    required: 'Required',
    select_collection_items: 'Select collection items',
    add_custom_collection_item: 'Add custom collection item',
    system_field: 'System',
    edit: 'Edit',
    please_select: 'Please select ',
    please_enter: 'Please enter ',
    please_upload: 'Please upload',
    yes: 'Yes',
    no: 'No',
    submit: 'Submit',
    mobile: 'Mobile number',
    remark: 'Remarks',
    save: 'Save',
    parent_type: 'Parent category',
    type_id: 'Category ID',
    type_name: 'Category name',
    small_img: 'Thumbnail',
    child_type_limit: 'Child category limit',
    child_type_limit_extra: 'Allows selection of tickets within several subcategories under this category. 0 means no limit. This setting is ignored if there are no subcategories.',
    ticket_limit: 'Ticket limit',
    ticket_limit_extra: 'Allows selection of several types of tickets under this category. 1 means single choice, 0 means no limit (multiple choices), other values mean multiple choices.',
    please_enter_ticket_limit: 'Please enter the number of tickets that can be selected within this category',
    ticket_count_limit: 'Ticket quantity limit',
    ticket_count_limit_extra: 'Allows selection of a certain number of tickets under this category. 1 means single choice, 0 means no limit (multiple choices), other values mean multiple choices.',
    sort: 'Sort',
    sort_extra: 'The larger the value, the higher the position',
    status: 'Status',
    description_text: 'Description text',
    only_upload_image: 'You can only upload image files',
    please_upload_file: 'Please upload a file in {type} format',
    is_open_inv_label: 'Whether to enable invoice information collection',
    is_open_inv_checked: 'Open',
    is_open_inv_unchecked: 'Close',
    inv_collect_deadline_label: 'Invoice collection deadline',
    inv_collect_deadline_extra:
        'Note: If the invoice collection deadline is not filled in, there will be no limit by default! If filled in, the front-end invoice collection will be processed according to the deadline.',
    inv_type_label: 'Invoice type',
    inv_type_ordinary: 'VAT ordinary invoice',
    inv_type_special: 'VAT special invoice',
    inv_type_electronic: 'VAT electronic ordinary invoice',
    invoice_display_label: 'Whether invoice information is required',
    invoice_display_extra: 'If you need participants to fill in invoice information, please select "Yes"; if you allow participants to choose not to receive an invoice, please select "No".',
    allowed_personal_label: 'Whether personal invoices are allowed',
    receipt_dow_label: 'Registration fee receipt download',
    receipt_dow_checked: 'Open',
    receipt_dow_unchecked: 'Close',
    receipt_tpl_label: 'Registration fee receipt template',
    receipt_tpl_extra: 'It is recommended that the file size be less than 3M, supporting doc and docx formats',
    receipt_tpl_download: 'Download English receipt template',
    upload_file_text: 'Upload file',
    view_file_text: 'View',
    receipt_tpl_required: 'Please upload the registration fee receipt template',
    addition_receipt_dow_label: 'Additional activity fee receipt download',
    addition_receipt_tpl_label: 'Additional activity fee receipt template',
    addition_receipt_tpl_download: 'Download English additional activity receipt template',
    addition_receipt_tpl_required: 'Please upload the additional activity fee receipt template',
    accompany_receipt_dow_label: 'Accompanying fee receipt download',
    accompany_receipt_tpl_label: 'Accompanying fee receipt template',
    accompany_receipt_tpl_download: 'Download English accompanying receipt template',
    accompany_receipt_tpl_required: 'Please upload the accompanying fee receipt template',
    save_button_text: 'Save',
    config_label_notice: 'When configuring domain labels, please read',
    config_label_doc: '《Domain Label Configuration Usage Instructions》',
    label_info_title: 'Domain label information',
    save_success: 'Saved successfully',
    only_doc: 'Only doc and docx format files can be uploaded',
    file_size_limit: 'The file size cannot exceed 3M',
    user_name: 'User name',
    order_no: 'Order number',
    pay_way: 'Payment method',
    pay_status: 'Payment status',
    pay_finished: 'Paid',
    pay_wait: 'Pending payment',
    refund_status: 'Refund status',
    refund_wait: 'Not refunded',
    refund_finished: 'Refund completed',
    refund_fail: 'Refund rejected',
    refund_ing: 'Refunding',
    refund_apply: 'Apply for refund',
    audit_status: 'Audit status',
    audit_wait: 'Pending audit',
    audit_pass: 'Audited',
    audit_fail: 'Audit failed',
    no_audit: 'No audit required',
    money: 'Amount',
    to: 'To',
    is_open_register: 'Whether to open ticket reservations',
    open: 'Open',
    close: 'Close',
    template_selection: 'Template selection',
    registration_deadline: 'The deadline for ticket reservation',
    registration_button_text: 'Personal Center Menu Reservation Button Text',
    custom_registration_address: 'Custom registration address',
    is_open_group_purchase: 'Whether group purchase is enabled',
    show_ticket_holder_menu_default_yourself_as_ticket_holder_but_cannot_add_or_invite_only_one_ticket_per_purchase:
        'Show ticket holder menu, yourself as default ticket holder, but cannot add or invite, only one ticket per purchase',
    ticket_holder_list_can_be_added_and_invited_select_or_supplement_ticket_holder_information_after_selecting_multiple_tickets_and_then_pay:
        'Ticket holder list can be added and invited, after selecting multiple tickets, select or supplement ticket holder information then proceed to payment',
    open_for_others_to_purchase_tickets: 'Open - Purchase tickets for others',
    close_only_allow_yourself_to_purchase_tickets: 'Close - Only allow self purchase',
    is_verify_ticket_holder_information: 'Whether to verify ticket holder information',
    do_not_verify_whether_the_mobile_phone_number_of_the_ticket_holder_is_duplicated: 'Do not verify whether the mobile phone number of the ticket holder is duplicated',
    verify_whether_the_mobile_phone_number_of_the_ticket_holder_is_duplicated_in_this_conference: 'Verify whether the mobile phone number of the ticket holder is duplicated in this conference',
    no_do_not_verify_whether_the_mobile_phone_number_of_the_ticket_holder_is_duplicated: 'No, do not verify whether the mobile phone number of the ticket holder is duplicated',
    yes_verify_whether_the_mobile_phone_number_of_the_ticket_holder_is_duplicated: 'Yes, verify whether the mobile phone number of the ticket holder is duplicated',
    can_pay_after_registration_deadline: 'Can I pay after the ticket deadline',
    unpaid_orders_can_be_paid: 'Unpaid orders can be paid',
    unpaid_orders_cannot_be_paid_anymore: 'Unpaid orders can no longer be paid',
    audit_information_method: 'Method of submitting audit information',
    submit_one_audit_information_for_each_order_regardless_of_the_number_of_tickets_purchased: 'Submit one audit information per order regardless of the number of tickets purchased',
    each_ticket_holder_of_each_ticket_must_submit_one_audit_information: 'Each ticket holder of each ticket must submit one audit information',
    submit_information_by_order: 'Submit information by order',
    submit_information_by_ticket_holder: 'Submit information by ticket holder',
    payment_audit_method: 'Payment audit method',
    audit_first_then_pay: 'Audit first then pay',
    pay_first_then_audit: 'Pay first then audit',
    perfect_information_configuration: 'Perfect information configuration',
    after_registering_an_account_and_logging_in_there_is_no_need_to_perfect_the_conference_registration_form_perfect_information_when_purchasing_tickets:
        'After registering an account and logging in, there is no need to complete the conference registration form; perfect information when purchasing tickets',
    after_registering_an_account_and_logging_in_you_must_perfect_the_conference_registration_form_before_you_can_continue_operating:
        'After registering an account and logging in, you must complete the conference registration form before continuing operations',
    need_to_perfect_information_after_logging_in: 'Need to perfect information after logging in',
    need_to_perfect_information_when_purchasing_tickets: 'Need to perfect information when purchasing tickets',
    personal_center_login_page_title: 'Personal center login page title',
    personal_center_login_page_text_description: 'Personal center login page text description',
    please_enter_prompt_content: 'Please enter prompt content',
    upload_img: 'Upload image',
    only_upload_doc_image: 'Only doc, docx format and images can be uploaded',
    upload_doc_file: 'Please upload a document with .docx extension',
    please_enter_the_correct_id_card_number: 'Please enter the correct ID card number',
    please_enter_the_correct_email: 'Please enter the correct email',
    please_enter_the_correct_phone_number: 'Please enter the correct phone number',
    the_phone_number_already_exists: 'This phone number already exists, please use this phone number to log in directly or retrieve your password!',
    sms_verification: 'SMS verification',
    please_enter_the_verification_code: 'Please enter the verification code',
    set_password: 'Set password',
    please_enter_password: 'Please enter password',
    password_cannot_be_empty: 'Password cannot be empty',
    password_must_be_a_combination_of_letters_lowercase_numbers_uppercase_special_characters_and_at_least_6_characters:
        'Password must be a combination of lowercase letters, numbers, uppercase letters, and special characters, and must be at least 6 characters long!',
    confirm_password: 'Confirm password',
    please_confirm_password: 'Please confirm password',
    the_id_card_number_format_is_incorrect: 'The ID card number format is incorrect',
    signed_in: 'Checked in',
    not_signed_in: 'Not checked in',
    you_two_input_passwords_are_not_the_same: 'The two passwords you entered do not match!',
    the_id_card_number_is_incorrect: 'The ID card number is incorrect',
    the_account_format_is_incorrect: 'The account format is incorrect!',
    please_select_icon: 'Please select an icon',
    please_upload_file_type: 'Please upload a file of {type} type',
    add_options : 'items',
    status_on: 'On',
    status_off: 'Off',
    is_audit_label: 'Whether the registration information needs to be reviewed',
    audit_remark: 'Audit Explanation Text',
    audit_title: 'Form review configuration',
    audit_tips: 'Users should complete the registration form or wait for the review after registration. Only after the review is passed can they purchase tickets',
    user_register: 'Whether to enable the registration for the conference',
    user_register_tips: 'The login page shows the new user registration button',
    is_use_meeting: 'Whether to use the meeting configuration'
};

export default formConfig;
